// components
import { Typography } from '@centria-ui-atoms/typography'

// types
import type { FC } from 'react'

export type AuthHeroQuoteProps = {
  label: string
  author?: string
}

export const AuthHeroQuote: FC<AuthHeroQuoteProps> = ({
  label,
  author = 'Anónimo'
}) => (
  <div>
    <Typography fontcolor='white' fontSize='small'>
      &quot; {label} &quot;
    </Typography>
    <div className='text-end'>
      <Typography fontcolor='white' fontSize='subtitle' fontWeight='semiBold'>
        {author}
      </Typography>
    </div>
  </div>
)
